module.exports = __webpack_public_path__ + "static/media/clipboard-list.8b684578.svg";